import React from 'react';
import styles from './components.module.scss';
import { Checkbox } from '@material-ui/core';

export default function AutocompleteCheckbox({ checked }) {
  return (
    <Checkbox classes={{ root: styles.checkbox, checked: styles.checked }} checked={checked} />
  );
}
